var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0115 13.8711V15.3536H18.427L16.4268 13.4827L14.4265 15.3536H12.8416V13.8711L14.8418 12.0001L12.8416 10.1291V8.64697H14.4265L16.4268 10.518L18.427 8.64697H20.0115V10.1291L18.0113 12.0001L20.0115 13.8711ZM9.5804 4.43151C10.0596 3.98331 10.4515 4.135 10.4515 4.76939V19.2309C10.4515 19.8649 10.0596 20.0165 9.5804 19.5687L5.07418 15.3536H2.08696V8.64697H5.07418L9.5804 4.43151Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume-mute.d37473fc2616b592706bb0187195c883.svg";
export { ForwardRef as ReactComponent };